<!--
	To do the cool click-on-image-zoom-it-and-go-to-next-page-thing.
	The CaseViewHero takes care of removing the clone when new page is loaded.
-->

<template>
  <div
    class="zoom-image"
    :class="{'instantiated': isInstantiated, 'zooming': isZooming}"
    :style="{
        'top': position.top,
        'left': position.left,
        'width': position.width,
        'height': position.height
    }"
  >
    <div class="image" :style="{'background-image': imageToZoom}"></div>
    <div class="backdrop"></div>
  </div>
</template>

<script>
export default {
  name: "ZoomImage",
  props: {
    imageToZoom: String,
    isInstantiated: Boolean,
    initPosition: Object,
    targetUrl: String
  },
  data() {
    return {
      position: this.initPosition,
      isZooming: false
    };
  },
  watch: {
    initPosition() {
      this.position = this.initPosition;
    },
    isInstantiated() {
      // The clone must live after trigger-page is unmounted
      document.body.appendChild(this.$el);
      this.zoom();
    }
  },
  methods: {
    zoom() {
      const currentBox = this.$el.getBoundingClientRect();
      const currentSize = {
        width: currentBox.width,
        height: currentBox.height
      };
      const targetSize = {
        width: parseFloat(this.initPosition.width),
        height: parseFloat(this.initPosition.height)
      };

      // Only change to full size after clone accually have same size as original
      if (
        currentSize.width === targetSize.width &&
        currentSize.height === targetSize.height
      ) {
        this.isZooming = true;
        this.position = {
          top: 0 + "px",
          left: 0 + "px",
          width: window.innerWidth + "px",
          height:
            window.innerHeight * (window.innerWidth <= 400 ? 0.7 : 1.2) + "px"
        };

        // Store reference to this element, so we can remove it when next page is loaded
        this.$store.commit("addCloneElement", this.$el);

        this.$el.addEventListener("transitionend", this.goToNextUrl, false);
        this.$el.addEventListener(
          "webkitTransitionEnd",
          this.goToNextUrl,
          false
        );

        // Stop checking
        return;
      }

      // If element size != target size: do this check again
      requestAnimationFrame(this.zoom);
    },
    goToNextUrl() {
      this.$router.push({
        name: "case",
        params: {
          url: this.targetUrl
        }
      }).catch(err => {});
    }
  }
};
</script>

<style lang="scss">
@import "../scss/globals.scss";

@keyframes expand {
  from {
    height: 0;
  }
  to {
    height: 30vh;
  }
}

.zoom-image {
  display: none;
  position: fixed;
  z-index: 10;

  .image {
    transition: transform 0.6s cubic-bezier(0.86, 0, 0.07, 1);
    background-position: center center;
    background-size: cover;
    width: 100%;
    height: 100%;
  }

  .backdrop {
    @media screen and (max-width: 440px) {
      transition: transform 0.6s cubic-bezier(0.86, 0, 0.07, 1);
      transform-origin: top;
      transform: scaleY(0);
      content: "";
      position: absolute;
      height: 30vh;
      bottom: -30vh;
      background: white;
      width: 100%;
    }
  }

  &.instantiated {
    display: block;
  }

  &.zooming {
    transition: all 0.6s cubic-bezier(0.86, 0, 0.07, 1);
    -moz-transition: all 0.6s cubic-bezier(0.86, 0, 0.07, 1);

    .backdrop {
      transform: scaleY(1);
    }
  }
}
</style>
